/**
 * Shared menu shapes. xp.css has no dropdown-menu component, so IE, Explorer
 * and Notepad all drive the same hand-built `<MenuBar>` with this data.
 */

export interface MenuItem {
  /** Renders a horizontal rule instead of an entry. */
  separator?: boolean;
  label?: string;
  /** Right-aligned accelerator text, e.g. `Ctrl+O`. */
  shortcut?: string;
  icon?: string;
  disabled?: boolean;
  /**
   * The verb a double-click would run. Context menus draw it in bold, which is
   * the only place it means anything — a menu bar has no default.
   */
  defaultVerb?: boolean;
  /** Draws a check mark in the gutter. */
  checked?: boolean;
  /** Draws a radio bullet in the gutter. */
  radio?: boolean;
  onSelect?: () => void;
  /** Nested submenu; mutually exclusive with `onSelect` in practice. */
  items?: MenuItem[];
}

export interface MenuDefinition {
  /** Top-level label, e.g. `File`. The character after `&` is underlined. */
  label: string;
  items: MenuItem[];
}

export const separator: MenuItem = { separator: true };
